(() => {
  'use strict';
  const initialized = new WeakSet();
  function initialize(root) {
    root.querySelectorAll('form.nuitalie-contact-form').forEach((form) => {
      if (initialized.has(form)) return;
      initialized.add(form);
      const message = form.querySelector('textarea[name="contact[body]"]');
      const email = form.querySelector('input[name="contact[email]"]');
      const feedback = form.querySelector('[data-contact-feedback]');
      if (feedback) feedback.focus();
      if (!message || !email) return;
      const validateMessage = () => {
        message.setCustomValidity(message.value.trim() ? '' : message.dataset.emptyMessage);
        if (message.validity.valid) message.removeAttribute('aria-invalid');
      };
      message.addEventListener('input', validateMessage);
      email.addEventListener('input', () => {
        if (email.validity.valid) email.removeAttribute('aria-invalid');
      });
      form.addEventListener('submit', (event) => {
        validateMessage();
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
        }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
